module.exports = __webpack_public_path__ + "static/assets/8505df165b778979791da5caaee96fea.png";